export default {
  API_ERROR: "Sorry, something went wrong. Please try again.",
  FORM_ERROR: "Sorry, but you need to write a bit more to share your feedback with us."
}
